import { render } from "./OtomeNoTome.vue?vue&type=template&id=0d5f4322"
import script from "./OtomeNoTome.vue?vue&type=script&lang=js"
export * from "./OtomeNoTome.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__